export enum UrgentOrderTimeSlotEnum {
    AM = 'AM'
    , PM = 'PM'
    , TPM = 'TPM'
}


// WEBPACK FOOTER //
// ./src/enums/urgentordertimeslot.enum.ts